import { Card, Col, Flex, Row, Tag, Tooltip } from "antd";
import React, { Component, useState, useEffect } from "react";
import CustomTitle from "../../components/CustomTitle";
import CustomParagraph from "../../components/CustomParagraph";
import {
  ExclamationCircleFilled,
  WarningOutlined,
  CheckCircleOutlined,
} from "@ant-design/icons";
import LocalShipping from "../../assets/images/20road.png";
import AirplaneFlying from "../../assets/images/20air.png";
import { appHelper } from "../../common/helper";
import { calc } from "antd/es/theme/internal";
import TeamBadge from "../../components/TeamBadge";

function ShipmentCard({ card, toggleDrawer, openShipmentId, drawerState }) {
  const type = card?.type;
  const isCardOpen = openShipmentId === card?.id;
  const { capitalize } = appHelper();
  const [legs, setLegs] = useState([]);
  const TagColor = {
    0: "#FFF0EE",
    1: "#FDF2DC",
    2: "#EAF6ED",
    3: "#28a745",
    4: "#F3F3F3",
    5: "#F3F3F3",
    6: "#F3F3F3",
    7: "#F3F3F3",
  };

  const TextColor = {
    0: "#DE1135",
    1: "#9F6402",
    2: "#0E8345",
    3: "#fff",
    4: "#4b4b4b",
    5: "#5E5E5E",
    6: "#4b4b4b",
    7: "#4b4b4b",
  };

  const tagColor = card?.status === "DELIVERED" ? "#28a745" : "#FFF0EE";
  const textColor = card?.status === "DELIVERED" ? "#fff" : "#DE1135";

  const iconMap = {
    road: LocalShipping,
    sky: AirplaneFlying,
  };
  const truncateByLength = (text, maxLength = 23) => {
    if (!text) return "";
    return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;
  };

  useEffect(() => {
    if (card && card?.legs_info?.legs && card?.legs_info?.legs?.length > 0) {
      setLegs(card?.legs_info?.legs);
    } else {
      setLegs([]);
    }
  }, [card]);

  return (
    <>
      <Card
        style={{
          borderRadius: "12px",
          border: "2px solid",
          cursor: "pointer",
          height: "fit-content",
          // minHeight:'124px',
          borderColor: isCardOpen ? "#266EF1" : "#EEE",
        }}
        bodyStyle={{ padding: "15px 15px" }}
        onClick={() => toggleDrawer("open", "Detail", card?.id)}
      >
        <Row
          gutter={[24, 16]}
          style={{ marginBottom: "0" }}
          justify="space-between"
        >
          <Col
            xxl={drawerState.isOpen ? 4 : 4}
            xl={drawerState.isOpen ? 4 : 4}
            lg={drawerState.isOpen ? 24 : 5}
            md={drawerState.isOpen ? 24 : 24}
            sm={drawerState.isOpen ? 24 : 24}
          >
            <div style={{ display: 'flex', flexDirection: 'column' }}>
            {(card?.reference_number?.length || 0) > 23 ? (
              <Tooltip title={card.reference_number}>
                <span>
                  <CustomTitle
                    text={truncateByLength(card.reference_number, 23)}
                    fontSize={12}
                    fontWeight={600}
                    lineHeight="20px"
                    color="#000"
                    marginBottom="4px"
                    style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      maxWidth: drawerState.isOpen ? "250px" : "400px",
                      display: "inline-block",
                    }}
                  />
                </span>
              </Tooltip>
            ) : (
              <CustomTitle
                text={card.reference_number}
                fontSize={12}
                fontWeight={600}
                lineHeight="20px"
                color="#000"
                marginBottom="4px"
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  maxWidth: drawerState.isOpen ? "250px" : "400px",
                 // display: "inline-block",
                }}
              />
            )}

            <Tag
              color={TagColor[type]}
              style={{
                borderRadius: "8px",
                color: TextColor[type],
                fontSize: "10px",
                width: "fit-content",
              }}
            >
              {(type == 0 || type == 4) && (
                <ExclamationCircleFilled
                  color={TextColor[type]}
                  style={{ marginRight: "4px" }}
                />
              )}
              {type == 1 && (
                <WarningOutlined
                  color={TextColor[type]}
                  style={{ marginRight: "4px" }}
                />
              )}
              {(type == 2 || type == 3) && (
                <CheckCircleOutlined
                  color={TextColor[type]}
                  style={{ marginRight: "4px" }}
                />
              )}
              {card?.status}
            </Tag>
            </div>
          </Col>
          <Col
            xxl={drawerState.isOpen ? 7 : 7}
            xl={drawerState.isOpen ? 7 : 7}
            lg={drawerState.isOpen ? 10 : 8}
            md={drawerState.isOpen ? 24 : 12}
            sm={drawerState.isOpen ? 24 : 12}
            xs={drawerState.isOpen ? 24 : 24}
          >
            <CustomParagraph
              text={card?.from_location?.name}
              fontSize={12}
              fontWeight={500}
              lineHeight="20px"
              color="#000"
              marginBottom="0"
            />
            <CustomParagraph
              text={
                [
                  card?.from_location?.parsed_address?.PlaceName,
                  card?.from_location?.parsed_address?.StateName,
                  card?.from_location?.parsed_address?.ZipCode,
                ]
                  .filter(Boolean) // Remove null, undefined, or empty values
                  .join(", ") // Join the remaining values with a comma and space
              }
              fontSize={12}
              fontWeight={400}
              color="#4b4b4b"
              marginBottom="0"
            />

            {/* <CustomParagraph text={card?.from_location?.parsed_address?.place_name,card?.from_location?.parsed_address?.state_name + '' + card?.from_location?.parsed_address?.occupancy_identifier} fontSize={14} fontWeight={400} color="#4b4b4b"  marginBottom="0"/> */}
            <CustomParagraph
              text={card?.scheduled_pickup_date}
              fontSize={12}
              fontWeight={400}
              color="#4b4b4b"
              marginBottom="4px"
            />

            {/* <CustomParagraph text={card.shipmentLegs[0].departureDateTimeUtc} fontSize={14} fontWeight={500} lineHeight="20px" color="#4B4B4B" marginBottom="0" /> */}
          </Col>
          <Col
            xxl={drawerState.isOpen ? 7 : 7}
            xl={drawerState.isOpen ? 7 : 7}
            lg={drawerState.isOpen ? 10 : 8}
            md={drawerState.isOpen ? 24 : 12}
            sm={drawerState.isOpen ? 24 : 12}
            xs={drawerState.isOpen ? 24 : 24}
          >
            <Flex
              className="shipment-location"
              align="flex-end"
              vertical={true}
              style={{ textAlign: "right" }}
            >
              <CustomParagraph
                text={card?.to_location?.name}
                fontSize={12}
                fontWeight={500}
                lineHeight="20px"
                color="#000"
                marginBottom="0"
              />
              {/* <CustomParagraph text={card?.to_location?.address} fontSize={14} fontWeight={400} color="#4b4b4b" marginBottom="0" /> */}
              <CustomParagraph
                text={
                  [
                    card?.to_location?.parsed_address?.PlaceName,
                    card?.to_location?.parsed_address?.StateName,
                    card?.to_location?.parsed_address?.ZipCode,
                  ]
                    .filter(Boolean) // Remove null, undefined, or empty values
                    .join(", ") // Join the remaining values with a comma and space
                }
                fontSize={12}
                fontWeight={400}
                color="#4b4b4b"
                marginBottom="0"
              />
              <CustomParagraph
                text={card?.scheduled_delivery_date}
                fontSize={12}
                fontWeight={400}
                color="#4b4b4b"
                marginBottom="4px"
              />
              {/* <CustomParagraph text={card.shipmentLegs[0].arrivalDateTimeUtc} fontSize={14} fontWeight={500} lineHeight="20px" color="#4B4B4B" marginBottom="0" /> */}
            </Flex>
          </Col>
        </Row>

        <Row gutter={[24, 16]} className="shipment-progress">
          <Col
            xxl={drawerState.isOpen ? 7 : 7}
            xl={drawerState.isOpen ? 7 : 7}
            lg={drawerState.isOpen ? 24 : 7}
            md={drawerState.isOpen ? 24 : 24}
            sm={drawerState.isOpen ? 24 : 24}
          >
            <Flex gap={8} style={{ marginTop: "4px", flexWrap: "wrap" }}>
              {card?.teams?.length > 0 && (
                <div className="flex white-space-nowrap">
                  <TeamBadge
                    className="mr-1"
                    color={card?.teams[0]?.color}
                    text={card?.teams[0]?.name}
                    tooltipText={card?.teams[0]?.name}
                  />
                  {card?.teams.length > 1 && (
                    <Tooltip
                      title={card.teams
                        .slice(1)
                        .map((team) => team.name)
                        .join(", ")}
                      placement="top"
                    >
                      <div
                        style={{ display: "inline-block", cursor: "pointer" }}
                      >
                        <TeamBadge
                          color={null}
                          text={`+ ${card?.teams.length - 1}`}
                        />
                      </div>
                    </Tooltip>
                  )}
                </div>
              )}
              <CustomParagraph
                text={capitalize(card?.courier?.title) || ""}
                fontSize={12}
                fontWeight={500}
                color="#AFAFAF"
                marginBottom="4px"
              />
            </Flex>
          </Col>

          <Col
            xxl={drawerState.isOpen ? 17 : 17}
            xl={drawerState.isOpen ? 17 : 17}
            lg={drawerState.isOpen ? 24 : 17}
            md={drawerState.isOpen ? 24 : 24}
            sm={drawerState.isOpen ? 24 : 24}
          >
            <Flex align="center" style={{ height: "100%", marginLeft: "8px" }}>
              {/* <ul className="custom-steps-display">
                                <li className="active">
                                    <img src={AirplaneFlying} alt="" style={{ right: "-20px" }} />
                                </li>
                                <li>
                                    <img src={LocalShipping} alt="" style={{ right: "-18px" }} />
                                </li>
                                <li></li>
                            </ul> */}

              {legs && legs.length > 0 ? (
                <ul className="custom-steps-display">
                  {legs.map((leg, index) => {
                    let w = leg?.distribution;
                    return (
                      <li
                        key={index}
                        className={leg.status === "travelled" ? "active" : ""}
                        style={{ width: `${w}%`, marginRight: "4px" }} // Fixed template literal
                      >
                        {leg.status == "travelled" && (
                          <div
                            className="centerImage"
                            style={{
                              width: "24px",
                              paddingLeft: "2px",
                              paddingRight: "2px",
                              backgroundColor: "white",
                            }}
                          >
                            <img
                              src={
                                leg.mode === "truck"
                                  ? LocalShipping
                                  : AirplaneFlying
                              }
                              alt=""
                            />
                          </div>
                        )}
                      </li>
                    );
                  })}
                </ul>
              ) : (
                <ul className="custom-steps-display">
                  <li style={{ width: "100%" }}></li>
                </ul>
              )}

              {/* <ul className="custom-steps-display">
                                {card?.shipment_progress?.map((progress, index) => (
                                    <li
                                        key={index}
                                        className={index === 0 ? "active" : ""}
                                        style={{ position: "relative" }}
                                    >
                                    {iconMap[progress] && (
                                        <img
                                            src={iconMap[progress]}
                                            alt={progress}
                                            style={{ right: `${-20 + index * 2}px` }}
                                        />
                                    )}
                                    </li>
                                ))}
                            </ul> */}
            </Flex>
          </Col>
        </Row>
      </Card>
    </>
  );
}

export default ShipmentCard;
